module.exports = __webpack_public_path__ + "static/RamsaTeam-daaf5d0dffd739eee55d1070a03f69f3.jpg";